// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  width: 100%;\n  min-width: 1366px;\n  height: 100vh;\n  overflow: scroll;\n  background-color: #f8fbff;\n}\n", ""]);
// Exports
module.exports = exports;
